export async function retry<T>(
  fn: () => Promise<T>,
  {
    retries = 2,
    delay = 2000,
    getDelay,
  }: {
    retries?: number
    delay?: number
    getDelay?: (error: unknown, attempt: number) => number | undefined
  } = {}
): Promise<T> {
  let attempt = 0

  while (true) {
    try {
      return await fn()
    } catch (error) {
      if (attempt >= retries) {
        throw error
      }
      attempt++
      const waitMs = getDelay?.(error, attempt) ?? delay
      await new Promise(resolve => setTimeout(resolve, waitMs))
    }
  }
}
